import type { QuestionAnswerLog } from '@pbt/pbt-ui-components'

import type { QuestionLog } from '~/utils/questionUtils'

import QuestionsListWidgetLockedItem from './QuestionsListWidgetLockedItem'

const QuestionsListWidgetLockedFollowUpItem = ({
  question,
}: {
  question: QuestionLog
}) => {
  const followUps =
    question.answers?.reduce(
      (selectedFollowUps: QuestionLog[], current: QuestionAnswerLog) => {
        const { followUpQuestionLog, selected } = current
        if (followUpQuestionLog && selected) {
          return [...selectedFollowUps, followUpQuestionLog]
        }
        return selectedFollowUps
      },
      [],
    ) || []

  return (
    <>
      <QuestionsListWidgetLockedItem question={question} />
      {followUps.map((followUpQuestion) => (
        <QuestionsListWidgetLockedItem
          key={followUpQuestion.id}
          paddingLeft={2}
          question={followUpQuestion}
        />
      ))}
    </>
  )
}

export default QuestionsListWidgetLockedFollowUpItem
